import type { ReactNode } from 'react';

export function Marginalia({ children }: { children: ReactNode }) {
  return (
    <aside className="relative pl-5 border-l border-l-rule font-display italic text-l-marginalia text-[15px] leading-[1.5]">
      {children}
    </aside>
  );
}
